// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/contractor_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { ContractorService } from "./contractor_service_pb";

/**
 * @generated from rpc bffuser.v1.ContractorService.ListContractors
 */
export const listContractors = ContractorService.method.listContractors;

/**
 * @generated from rpc bffuser.v1.ContractorService.CreateContractor
 */
export const createContractor = ContractorService.method.createContractor;

/**
 * @generated from rpc bffuser.v1.ContractorService.UpdateContractor
 */
export const updateContractor = ContractorService.method.updateContractor;

/**
 * @generated from rpc bffuser.v1.ContractorService.DeleteContractor
 */
export const deleteContractor = ContractorService.method.deleteContractor;
